import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import LibraryComponents from "../components/template/library-components/library-components";
import React from "react";


const contentfulRenderOptions = (contentfulText: any, classImage?: string, imagenPrincipal?: any[]) => {
    if (!contentfulText || !contentfulText.content) {
        console.error("El contenido proporcionado está vacío o es inválido.");
        return null;
    }
    const contentfulRender = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }: any, children) => (
                <a
                    style={{ color: "var(--color-magenta-white)" }}
                    href={data.uri}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                >
                    {children}
                </a>
            ),
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p>{children}</p>;
            },
            [BLOCKS.LIST_ITEM]: (node, children) => {
                // Extrae el texto plano del li
                let text = "";
                node.content.forEach((c: any) => {
                    if (c.nodeType === "paragraph" && c.content && c.content[0]?.value) {
                        text += c.content[0].value;
                    }
                });

                // Determina la imagen según el primer caracter
                let imgSrc = imagenPrincipal && imagenPrincipal[0].file.url;
                if (text.trim().startsWith("*") && imagenPrincipal && imagenPrincipal[1]) {
                    imgSrc = imagenPrincipal[1].file.url;
                }

                // Elimina el * inicial si existe
                const cleanText = text.trim().startsWith("*")
                    ? text.trim().substring(1).trim()
                    : text;

                return (
                    <li className="m-card-rates__feature">
                        {imgSrc && (
                            <img
                                src={typeof imgSrc === "string" ? imgSrc : imgSrc.url}
                                alt=""
                                style={{ width: 38, height: 38, marginRight: 8, verticalAlign: "middle" }}
                            />
                        )}
                        {cleanText}
                    </li>
                );
            },
            [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
                return (
                    <>
                        {classImage ? (
                            <div className={`${classImage}`}>
                                <img
                                    src={node.data.target.fields.file["en-US"] ?
                                        `https://${node.data.target.fields.file["en-US"].url}` : 
                                        `${node.data.target.fields.file.url}`}
                                    alt={node.data.target.fields.description}
                                />
                            </div>
                        ): <div>
                            <img
                                src={node.data.target.fields.file["en-US"] ?
                                    `https://${node.data.target.fields.file["en-US"].url}` : 
                                    `${node.data.target.fields.file.url}`}
                                alt={node.data.target.fields.description}
                            />
                        </div> }
                    </>
                );
            },
            [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
                return (
                    <LibraryComponents 
                        content={node.data.target.fields} 
                        tipoComponente={node.data.target.fields.tipoComponente}
                    />                    
                );
                
            }
        },
        renderText: (text) =>
            text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    }
    return documentToReactComponents(contentfulText, contentfulRender);
};

export default contentfulRenderOptions;